/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./frens.vue?vue&type=template&id=01baee35&scoped=true"
import script from "./frens.vue?vue&type=script&lang=js"
export * from "./frens.vue?vue&type=script&lang=js"
import style0 from "./frens.vue?vue&type=style&index=0&id=01baee35&prod&lang=scss"
import style1 from "./frens.vue?vue&type=style&index=1&id=01baee35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01baee35",
  null
  
)

export default component.exports